import i18next from "i18next";
import {
  initReactI18next
} from "react-i18next";

import enText from "@assets/locales/en.json";
import peText from "@assets/locales/pe.json";

i18next
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enText,
      },
      pe: {
        translation: peText,
      }
    },
    lng: "pe",
    fallbackLng: "pe",
    interpolation: {
      escapeValue: false
    }
  });

export default i18next;